const MAP = {
  abbinato: ["Abbinato", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  senza_email: ["Email mancante", "bg-amber-50 text-amber-800 border-amber-200"],
  non_trovato: ["Nuovo dipendente", "bg-[#eef6ef] text-[#3d6e49] border-[#b7d8bd]"],
  non_riconosciuto: ["Non riconosciuto", "bg-slate-100 text-slate-700 border-slate-300"],
  cessato: ["Cessato", "bg-rose-50 text-rose-700 border-rose-200"],
  inviato: ["Inviato", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  fallito: ["Fallito", "bg-red-50 text-red-700 border-red-200"],
  attivo: ["Attivo", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  da_inviare: ["Da inviare", "bg-slate-100 text-slate-700 border-slate-300"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = MAP[status] || [status, "bg-slate-100 text-slate-700 border-slate-300"];
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
};
